(function() {
  'use strict';

  // 1. Accordion Toggle (Values, Benefits, Trust)
  document.querySelectorAll('.pp-accordion__header').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.pp-accordion__item');
      var isOpen = item.getAttribute('data-open') === 'true';
      // Close all siblings
      item.parentElement.querySelectorAll('.pp-accordion__item').forEach(function(sibling) {
        sibling.setAttribute('data-open', 'false');
        sibling.querySelector('.pp-accordion__header').setAttribute('aria-expanded', 'false');
      });
      // Toggle clicked
      if (!isOpen) {
        item.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // 1b. FAQ Toggle
  document.querySelectorAll('.pp-faq-item__q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.pp-faq-item');
      var isOpen = item.getAttribute('data-open') === 'true';
      // Close all siblings
      item.parentElement.querySelectorAll('.pp-faq-item').forEach(function(sibling) {
        sibling.setAttribute('data-open', 'false');
        sibling.querySelector('.pp-faq-item__q').setAttribute('aria-expanded', 'false');
      });
      // Toggle clicked
      if (!isOpen) {
        item.setAttribute('data-open', 'true');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // 2. Scroll Reveal (Intersection Observer)
  var revealItems = document.querySelectorAll('.pp-reveal');
  if (revealItems.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealItems.forEach(function(el) { revealObs.observe(el); });
  }

  // 3. Timeline Progress
  var timeline = document.querySelector('.pp-timeline');
  var timelineProgress = document.querySelector('.pp-timeline__progress');
  var timelineSteps = document.querySelectorAll('.pp-timeline__step');
  if (timeline && timelineProgress && timelineSteps.length) {
    var timelineObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          var rect = entry.target.getBoundingClientRect();
          var tlRect = timeline.getBoundingClientRect();
          var pct = ((rect.bottom - tlRect.top) / tlRect.height) * 100;
          timelineProgress.style.height = Math.min(pct, 100) + '%';
        }
      });
    }, { threshold: 0.3 });
    timelineSteps.forEach(function(s) { timelineObs.observe(s); });
  }

  // 4. Reduced Motion Respekt
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.pp-reveal').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }
})();
